import { useAccDetContact } from "../../api/account/useAccDetContact";
import { useState } from "react";
import AddContacts from "./AddContacts";
import ContactsShowDetail from "./ContactsShowDetail";

const ContactsTab = ({leadID, accountOwner}) => {
    const {contactData, error, isLoading, refetch} = useAccDetContact({leadID});
    const [showModal, setShowModal] = useState(false);
    const [selectedContactModal, setSelectedContactModal] = useState(false);
    const [selectedContactIndex, setSelectedContactIndex] = useState(null);
    
    const handleContactAdded = () => {
        refetch();
    };
    
    return(
        <>
        <div className="w-full flex flex-col shadow-lg p-4 bg-white rounded-lg item-start">
            <div className="flex flex-row justify-between w-full items-center text-center">
                <h2 className="py-2 font-bold mb-4 text-xl">Contacts</h2>
                {accountOwner && (
                    <button 
                    className="rounded-full border border-[#1E293B] px-4 py-2"
                    onClick={() => setShowModal(true)}>
                        +  Add Contact
                    </button>
                )}
            </div>
            <table className="min-w-full bg-white border border-gray-200">
                <thead>
                    <tr className="bg-gray-100 border-none text-[#94A3B8]">
                        <th className="py-3 px-3 text-start text-lg">Name</th>
                        <th className="py-3 px-3 text-start text-lg">Designation</th>
                        <th className="py-3 px-3 text-start text-lg">Email</th>
                        <th className="py-3 px-3 text-start text-lg">Mobile Number</th>
                        <th className="py-3 px-3 text-start text-lg">Reporting To</th>
                        <th className="py-3 px-3 text-center text-lg">Last Edited At</th>
                        <th className="py-3 px-3 text-center text-lg">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        [...Array(3)].map((_, index) => (
                            <tr key={index} className="border-gray-200 border text-[#212121]">
                            <td className="py-3 px-3 text-start text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-3 px-3 text-start text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-3 px-3 text-start text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-3 px-3 text-start text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-3 px-3 text-center text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-3 px-3 text-center text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                        </tr>
                        ))
                    ) : contactData && contactData.length > 0 ? (
                        contactData.map((contact, index) => (
                            <tr key={index} className="border-gray-200 border text-[#212121] text-center">
                                <td className="py-3 px-3 text-start text-sm">{contact.frontend_name  || '-'}</td>
                                <td className="py-3 px-3 text-start text-sm">{contact.designation  || '-'}</td>
                                <td className="py-3 px-3 text-start text-sm">{contact.email || '-'}</td>
                                <td className="py-3 px-3 text-start text-sm">{contact.mobile_no || '-'}</td>
                                <td className="py-3 px-3 text-start text-sm">{contact.reporting_to}</td>
                                <td className="py-3 px-3 text-center text-sm">{contact.last_edited || '-'} </td>
                                <td className="py-3 px-3 flex justify-center items-center text-sm cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedContactIndex(index);
                                        setSelectedContactModal(true);
                                    }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
                                            </svg>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr className="border-gray-200 border text-[#212121]">
                            <td colSpan="7" className="py-3 px-3 text-center text-sm">No contacts available</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        <AddContacts 
            showModal={showModal}
            setShowModal={setShowModal}
            onContactAdded={handleContactAdded}
            leadID={leadID} />
        <ContactsShowDetail 
            selectedContactModal={selectedContactModal} 
            setSelectedContactModal={setSelectedContactModal} 
            contactData={ selectedContactModal ? contactData[selectedContactIndex] : null}
            onContactUpdated={handleContactAdded}
        />
        </>
    )
}

export default ContactsTab;